export const getError = state => state.editPeriodicity.get('error')
export const getIsSubmitting = state => state.editPeriodicity.get('isSubmitting')
